import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const addJob = async (postData) => {
  try {
    return await post<ApiResponse<[]>>("/individual/job", postData).then(
      (res) => {
        console.log("res",res);
        
        return res;
        // if (res?.success === true) {
        //   return res;
        // } else {
        //   return null;
        // }
      },
    ).catch((e)=>{
    //   console.log("addJob error",e.response);
      return e.response;
      throw e;
    });
  } catch (e) {
    HandleApiError(e);
  }
};
